<template>
  <div class="ivu-row-flex-end ivu-row-flex" style="margin-left: -12px;margin-right: -12px;">
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="订单号">
            <Input v-model="formItem.OrderID" disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="客户名称">
            <Input v-model="formItem.Customer_Name" disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="订单状态">
            <Select v-model="formItem.State"  value="formItem.State" :disabled="disabled" :class="OrderState?'SureState':'UnSureState'">
                <Option value="预付款待确认">预付款待确认</Option>
                <Option value="预付款已确认">预付款已确认</Option>
                <Option value="尾款待确认">尾款待确认</Option>
                <Option value="全额待确认">全额待确认</Option>
                <Option value="全额已确认">全额已确认</Option>
                <Option value="订单作废">订单作废</Option>
            </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="预付款">
            <Input type="Number" v-model="formItem.AdvanceCharge" placeholder="请输入预付款..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="尾款">
            <Input type="Number" v-model="formItem.TailMoney1" :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="总金额">
            <Input type="Number" v-model="formItem.Total1" placeholder="请输入总金额..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="已付金额">
            <Input type="Number" :value="computeTotaled" placeholder="请输入总金额..." disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="运费">
            <Input type="Number" v-model="Freight" placeholder="请输入运费..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="开票类型">
            <Input  v-model="formItem.BillingType"  readonly></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
           v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="收货地址">
            <Input v-model="formItem.Address" placeholder="请输入收货地址..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="收货人">
            <Input v-model="formItem.Contacts" placeholder="请输入收货人..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="收货电话">
            <Input v-model="formItem.Telephone" placeholder="请输入收货电话..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="销售员">
            <Input v-model="formItem.UserName" disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="备注">
            <Input v-model="formItem.Remark" placeholder="请输入备注..." :disabled="disabled"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="订单来源">
            <Input v-model="formItem.Order_Source" disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;"
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="生成时间">
            <Input v-model="formItem.StartTime" disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;"
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="完成时间">
            <Input v-model="formItem.ReceiveTime" disabled></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="SaveHandleClick" v-if="!disabled">保存</Button>
          <a href="#" @click.prevent="changeLimit">
            {{formItem.switch}}
            <Icon v-if="formItem.switch === '展开'" type="ios-arrow-down" />
            <Icon v-if="formItem.switch === '收起'" type="ios-arrow-up" />
          </a>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { ChangeOrderMainInfo } from '../../../../api/Order'
export default {
  name: 'OrderDetailHeader',
  props: {
    State: String,
    formItem: {
      OrderID: String,
      Customer_Name: String,
      State: String,
      AdvanceCharge: Number,
      TailMoney: Number,
      TailMoney1: Number,
      Total: Number,
      Total1: Number,
      Address: String,
      Contacts: String,
      Telephone: String,
      UserName: String,
      UserID: String,
      Freight: Number,
      Freight2: Number,
      Remark: String,
      Order_Source: String,
      StartTime: String,
      ReceiveTime: String,
      switch: String,
      BillingType: String
    }
  },
  data () {
    return {
      Role: false
    }
  },
  computed: {
    disabled: function () {
      if (this.State === '查看') {
        return true
      } else {
        return false
      }
    },
    OrderState: function () {
      const state = this.formItem.State
      if (state.indexOf('已确认') !== -1) {
        return true
      } else {
        return false
      }
    },
    computeTotaled: function () {
      let t = Number(this.formItem.Total)
      let f = Number(this.formItem.Freight)
      let f2 = Number(this.formItem.Freight2)
      let m = Number(this.formItem.TailMoney1)
      if (!t) { t = 0 }
      if (!m) { m = 0 }
      if (!f2) { f2 = 0 }
      if (!f) { f = 0 }
      return t - f2 + f - m
    },
    Freight: {
      get: function () {
        return this.formItem.Freight
      },
      set: function (value) {
        this.formItem.Freight = Number(value)
        let t = Number(this.formItem.Total)
        let f = Number(value)
        let f2 = Number(this.formItem.Freight2)
        let t1 = Number(this.formItem.TailMoney)
        if (!t) { t = 0 }
        if (!f) { f = 0 }
        if (!f2) { f2 = 0 }
        if (!t1) { t1 = 0 }
        this.formItem.Total1 = t - f2 + f
        this.formItem.TailMoney1 = t1 - f2 + f
      }
    }
  },
  mounted: function () {},
  methods: {
    changeLimit () {
      if (this.formItem.switch === '展开') {
        this.formItem.switch = '收起'
      } else { this.formItem.switch = '展开' }
    },
    // 点击保存按钮回调
    SaveHandleClick () {
      ChangeOrderMainInfo({
        OrderID: this.formItem.OrderID,
        State: this.formItem.State,
        AdvanceCharge: this.formItem.AdvanceCharge,
        TailMoney: this.formItem.TailMoney1,
        Total: this.formItem.Total1,
        Freight: this.formItem.Freight,
        Address: this.formItem.Address,
        Contacts: this.formItem.Contacts,
        Telephone: this.formItem.Telephone,
        Remark: this.formItem.Remark,
        LastModification_User: this.$store.state.userInfo.userID
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
<style scoped>
.SureState{
  color: #19be6b
}
.UnSureState{
  color: #ed4014
}
</style>>
